import React, { useState, useEffect } from "react";
import { FaSearch, FaTimes, FaBookOpen } from "react-icons/fa";
import "./BookLibrary.css";
import Footer from "./Footer";
import img1 from "../Assets/boookkk.jpg";
import img2 from "../Assets/Bk_Fel.png";
import img4 from "../Assets/Bk_Alex.jpg";
import img5 from "../Assets/Bk_AL3.jpg";
import img6 from "../Assets/Derick.jpeg";
import img7 from "../Assets/Lydia.png";
import img8 from "../Assets/Gibu.png";
import img9 from "../Assets/Baale.png";
import img10 from "../Assets/Moris.png";
import img12 from "../Assets/Wamibi.png";
import img13 from "../Assets/Mudeda.png";
import img14 from "../Assets/Malobaz.jpg";

const BOOKS = [
  { id: 1, title: "Power For Living", author: "Dr. Alex Mutagubya", description: "Discovering the power available to every believer for a victorious life.", image: img1 },
  { id: 2, title: "Unhindered", author: "Dr. Alex Mutagubya", description: "Overcoming the control and influence of the spirit.", image: img4 },
  { id: 3, title: "Ministry DNA", author: "Dr. Alex Mutagubya", description: "A guide to understanding God's purpose for your life.", image: img5 },
  { id: 6, title: "Digital Discipleship", author: "Bwire Felix", description: "A journey in church media.", image: img2 },
  { id: 7, title: "Through A Mum's Eyes", author: "Abote Priscilla Maloba", description: "Life lessons for my son.", image: img14 },
  { id: 8, title: "Overcoming Fear", author: "Derick Ongeiwun", description: "A practical guide to overcome your fears.", image: img6 },
  { id: 9, title: "The Art Of Serving Children", author: "Lydia Biira Kuhinira", description: "The world of children is a realm of endless curiosity, imagination and wonder.", image: img7 },
  { id: 10, title: "Fruitfulness", author: "Gerald W. Gibu", description: "The call for every child of God.", image: img8 },
  { id: 11, title: "The Wilderness Experience", author: "Henry Baale", description: "A powerful book on navigating the tough seasons of life.", image: img9 },
  { id: 12, title: "Godly Relationships Leading to Marriage", author: "Morris Okwakol", description: "A biblical perspective on today's contemporary relationships.", image: img10 },
  { id: 14, title: "The Enemy Within", author: "David Wamimbi Mulaamya", description: "Victory over self.", image: img12 },
  { id: 15, title: "Complete The Task", author: "Derick Mudeda", description: "Defying the urge to quit.", image: img13 },
];

function Book() {
  const [query, setQuery] = useState(() => {
    try { return localStorage.getItem("librarySearch") || ""; } catch { return ""; }
  });

  useEffect(() => {
    try { localStorage.setItem("librarySearch", query); } catch { /* ignore */ }
  }, [query]);

  const q = query.trim().toLowerCase();
  const filtered = q
    ? BOOKS.filter((b) => b.title.toLowerCase().includes(q) || b.author.toLowerCase().includes(q))
    : BOOKS;

  return (
    <>
      <header className="lib-hero">
        <div className="tcc-container lib-hero__inner">
          <p className="tcc-eyebrow lib-hero__eyebrow">Read &amp; grow</p>
          <h1 className="lib-hero__title">The Library</h1>
          <p className="lib-hero__lead">
            Books written by our pastors and church family, to help you grow in
            faith, leadership and everyday life.
          </p>
        </div>
      </header>

      <section className="tcc-section lib-section" aria-labelledby="lib-h">
        <div className="tcc-container">
          <div className="ev-head" style={{ marginBottom: "var(--space-6)" }}>
            <p className="tcc-eyebrow">Our shelf</p>
            <h2 className="tcc-h2" id="lib-h">Books by our church family</h2>
          </div>

          <div className="lib-search" role="search">
            <label htmlFor="lib-search-input" className="tcc-sr-only">Search books by title or author</label>
            <span className="lib-search__field">
              <FaSearch aria-hidden="true" className="lib-search__icon" />
              <input
                id="lib-search-input"
                type="search"
                className="lib-search__input"
                placeholder="Search by title or author..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />
              {query && (
                <button type="button" className="lib-search__clear" onClick={() => setQuery("")} aria-label="Clear search">
                  <FaTimes aria-hidden="true" />
                </button>
              )}
            </span>
          </div>

          <p className="lib-count" aria-live="polite">
            {filtered.length} {filtered.length === 1 ? "book" : "books"}
            {q && ` matching “${query.trim()}”`}
          </p>

          {filtered.length > 0 ? (
            <ul className="lib-grid">
              {filtered.map((book) => (
                <li key={book.id} className="lib-card tcc-card tcc-card--hover">
                  <div className="lib-card__media">
                    <img src={book.image} alt={`Cover of ${book.title}`} className="lib-card__img" loading="lazy" />
                  </div>
                  <div className="lib-card__body">
                    <h3 className="lib-card__title">{book.title}</h3>
                    <p className="lib-card__author">{book.author}</p>
                    <p className="lib-card__desc">{book.description}</p>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <div className="lib-empty">
              <FaBookOpen aria-hidden="true" />
              <p>No books match “{query.trim()}”.</p>
              <button type="button" className="tcc-btn tcc-btn--ghost" onClick={() => setQuery("")}>
                Clear search
              </button>
            </div>
          )}
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Book;
